import React from 'react';
import { ChevronLeftIcon } from './icons';

interface PageHeaderProps {
  title: string;
  onBack?: () => void;
  right?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, onBack, right }) => (
  <header className="flex items-center gap-3 px-4 py-3 bg-brand-50 border-0 border-b border-solid border-brand-300">
    {onBack && (
      <button
        type="button"
        onClick={onBack}
        aria-label="Go back"
        className="-ml-3 min-w-[44px] min-h-[44px] flex items-center justify-center bg-transparent border-0 cursor-pointer text-brand-800"
      >
        <ChevronLeftIcon />
      </button>
    )}
    <h1 className="flex-1 m-0 text-xl font-bold text-brand-900">{title}</h1>
    {right}
  </header>
);

export default PageHeader;
